import React, { useState, useEffect, useRef } from "react";

import { API, graphqlOperation } from "aws-amplify";

import { listLabels } from "../../graphql/queries";
import {
  onCreateLabel,
  onUpdateLabel,
  onDeleteLabel,
  onCreateArticleLabelJoin,
  onDeleteArticleLabelJoin,
} from "../../graphql/subscriptions";

import { Link } from "react-router-dom";

import Chip from "@mui/material/Chip";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";

import LabelDialog from "../../components/part/LabelDialog";

import CSSModules from "react-css-modules";
import style from "./LabelEdit.module.scss";

import Translate from "../../components/part/Translate";

function LabelEdit(props) {
  const { user, labels, setLabels, articleLabelItems, setArticleLabelItems, fetchArticle } = props;

  const refCreateDialog = useRef();
  const [, setLabelLength] = useState(3);
  const refsEditLabelDialog = useRef([React.createRef(), React.createRef(), React.createRef()]);

  const getLabels = React.useCallback(async () => {
    const res = await API.graphql(
      graphqlOperation(listLabels, {
        owner: user.username,
        // limit: 5,
        // nextToken: nextToken,
      })
    );

    setLabels(res.data.listLabels.items);
  }, [user.username, setLabels]);

  function updateLabelLength(value) {
    // console.log("updateLabelLength",value)
    setLabelLength(value);
    refsEditLabelDialog.current = refsEditLabelDialog.current.splice(0, value);
    for (let i = 0; i < value; i++) {
      refsEditLabelDialog.current[i] = refsEditLabelDialog.current[i] || React.createRef();
    }
  }

  const handleAddArticleLabelJoins = (labelId) => {
    let addedItems;
    addedItems = [...articleLabelItems, { labelId: labelId }];

    setArticleLabelItems(addedItems);
  };

  const handleDeleteArticleLabelJoins = (labelId) => {
    let filteredItems;
    filteredItems = articleLabelItems.filter((item) => {
      return item.labelId !== labelId;
    });
    setArticleLabelItems(filteredItems);
  };

  useEffect(() => {
    getLabels();

    const variables = {
      owner: user.username,
    };

    const createLabelSubscription = API.graphql(
      graphqlOperation(onCreateLabel, variables)
    ).subscribe({
      next: (msg) => {
        getLabels();
      },
      error: (err) => {
        console.error("Error in create label subscription:", err);
        createLabelSubscription.unsubscribe();
      },
    });

    const updateLabelSubscription = API.graphql(
      graphqlOperation(onUpdateLabel, variables)
    ).subscribe({
      next: (msg) => {
        getLabels();
      },
      error: (err) => {
        console.error("Error in update label subscription:", err);
        updateLabelSubscription.unsubscribe();
      },
    });

    const deleteLabelSubscription = API.graphql(
      graphqlOperation(onDeleteLabel, variables)
    ).subscribe({
      next: (msg) => {
        getLabels();
      },
      error: (err) => {
        console.error("Error in delete label subscription:", err);
        deleteLabelSubscription.unsubscribe();
      },
    });

    const createArticleLabelJoinSubscription = API.graphql(
      graphqlOperation(onCreateArticleLabelJoin, variables)
    ).subscribe({
      next: (msg) => {
        fetchArticle();
      },
      error: (err) => {
        console.error("Error in create article label join subscription:", err);
        createArticleLabelJoinSubscription.unsubscribe();
      },
    });

    const deleteArticleLabelJoinSubscription = API.graphql(
      graphqlOperation(onDeleteArticleLabelJoin, variables)
    ).subscribe({
      next: (msg) => {
        fetchArticle();
      },
      error: (err) => {
        console.error("Error in delete article label join subscription:", err);
        deleteArticleLabelJoinSubscription.unsubscribe();
      },
    });

    return () => {
      createLabelSubscription.unsubscribe();
      updateLabelSubscription.unsubscribe();
      deleteLabelSubscription.unsubscribe();
      createArticleLabelJoinSubscription.unsubscribe();
      deleteArticleLabelJoinSubscription.unsubscribe();
    };
  }, [fetchArticle, getLabels, labels, user.username]);

  useEffect(() => {
    !!labels && labels.length > 0 && updateLabelLength(labels.length);
  }, [labels]);

  return (
    <React.Fragment>
      <div className="label_select">
        {!!labels &&
          labels.length > 0 &&
          labels.map((item, i) => (
            <React.Fragment key={item.id}>
              {i >= 0 && (
                <React.Fragment>
                  {articleLabelItems.findIndex(
                    (articleLabelItem) => articleLabelItem.labelId === item.id
                  ) !== -1 ? (
                    <Chip
                      styleName="label-chip edit"
                      label={"#" + item.name}
                      size="small"
                      onDelete={() => handleDeleteArticleLabelJoins(item.id)}
                      style={{
                        backgroundColor: item.color,
                        color: item.color,
                      }}
                      onClick={() => handleDeleteArticleLabelJoins(item.id)}
                      className="label_chip_on"
                    />
                  ) : (
                    <Chip
                      styleName="label-chip edit"
                      label={"#" + item.name}
                      size="small"
                      onClick={() => handleAddArticleLabelJoins(item.id)}
                      className="label_chip_off"
                    />
                  )}
                  {/* <IconButton styleName="edit-icon" aria-label="edit" onClick={(event) => openEditDialog(item)}> */}
                  <IconButton
                    styleName="edit-icon"
                    aria-label="edit"
                    onClick={() => {
                      if (
                        !!refsEditLabelDialog.current[i] &&
                        !!refsEditLabelDialog.current[i].current
                      ) {
                        refsEditLabelDialog.current[i].current.setFormState({
                          ...refsEditLabelDialog.current[i].current.formState,
                          id: item.id,
                          name: item.name,
                          color: item.color,
                          owner: item.owner,
                          postedDate: item.postedDate,
                        });
                        refsEditLabelDialog.current[i].current.handleClickOpen();
                      }
                    }}
                    size="large"
                  >
                    <EditIcon fontSize="small" />
                  </IconButton>
                  <LabelDialog
                    ref={refsEditLabelDialog.current[i]}
                    title_id="edit_label"
                    label={item}
                    mode="update"
                  />
                </React.Fragment>
              )}
            </React.Fragment>
          ))}
      </div>
      <div>
        <Link
          styleName="next-to-previous"
          onClick={() => {
            refCreateDialog.current.handleClickOpen();
          }}
          to={{}}
          className="create_label"
        >
          <Translate id="create_label" />
        </Link>
        <LabelDialog ref={refCreateDialog} mode="create" title_id="create_label" />
      </div>
    </React.Fragment>
  );
}

export default CSSModules(LabelEdit, { ...style }, { allowMultiple: true });
